import app from '$$app';
import InlineEditors from '../../controllers/inlineEditors';
import massChangeContextMenu from '../../grid/massChangeContextMenu';
import massChangeSelectMenu from '../../grid/massChangeSelectMenu';
import webixContextMenu from '../../grid/webixContextMenu';
import keyboardNavigation from '../../grid/keyboardNavigation';

export default instance => {
  const previousScrollState = {
    y: 0,
  };

  instance.attachEvent('onGanttScroll', () => {
    app.trigger('hideResourcesListForTask');
    app.trigger('hideResourcesPreviewListForTask');

    massChangeContextMenu.hide();
    massChangeSelectMenu.hide();
    webixContextMenu.hide();
  });

  instance.attachEvent('onGanttScroll', () => {
    const { y: currentY } = instance.getScrollState();
    const isVerticalScroll = previousScrollState.y !== currentY;

    if (isVerticalScroll) {
      previousScrollState.y = currentY;

      if (InlineEditors.getState().columnName !== 'text' || !keyboardNavigation.creatingTask) {
        InlineEditors.hide();
      }
    }
  });
};
